// src/redux/actions/profileActions.js
import axios from "axios";
import { toast } from "react-hot-toast";

export const FETCH_PROFILE_REQUEST = "FETCH_PROFILE_REQUEST";
export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_FAILURE = "FETCH_PROFILE_FAILURE";

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE";

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchProfile = () => async (dispatch) => {
  dispatch({ type: FETCH_PROFILE_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/user_profile_info_emp`,
      {
        headers: {
          authorization: token,
        },
      }
    );

    const { data, meta } = response.data;

    if (meta?.status) {
       localStorage.setItem("userProfile", JSON.stringify(data));

      dispatch({ type: FETCH_PROFILE_SUCCESS, payload: data });
    } else {
      dispatch({ type: FETCH_PROFILE_FAILURE, payload: meta.message });
    }
  } catch (error) {
    dispatch({
      type: FETCH_PROFILE_FAILURE,
      payload: error.response?.data?.meta?.message || "Failed to fetch profile",
    });
  }
};

export const updateUserDetails = (formData) => async (dispatch) => {
  dispatch({ type: UPDATE_PROFILE_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${BASE_URL}/v1/api/user_profile_update`, formData, {
      headers: {
        authorization: token,
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: response.data });
    return response.data; // ✅ Important for component
  } catch (error) {
    const errorMessage =
      error.response?.data?.meta?.message ||
      error.response?.data?.message ||
      error.message ;

    dispatch({ type: UPDATE_PROFILE_FAILURE, payload: errorMessage });
    toast.error(errorMessage);

    return { meta: { status: false, message: errorMessage } }; // fallback
  }
};

// 🆕 UPDATE PASSWORD action
export const updatePassword = (credentials) => async (dispatch) => {
  dispatch({ type: UPDATE_PASSWORD_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/v1/api/employee-reset-password`, credentials, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    const { data, meta } = res.data;

    if (meta?.status) {

      dispatch({ type: UPDATE_PASSWORD_SUCCESS, payload: data });
      toast.success(meta.message);
    } else {
      dispatch({ type: UPDATE_PASSWORD_FAILURE, payload: meta.message });
      toast.error(meta.message);
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.meta?.message || "Something went wrong";
    dispatch({ type: UPDATE_PASSWORD_FAILURE, payload: errMsg });
    toast.error(errMsg);
  }
};
